import { SearchChatContentScreenProps } from "./types"
import React from "react"
import SearchChatContent from "./search-chat-content-screen"
import { PageRoot } from "~screens/page-root"


const GroupChatManagementScreen: React.FC<SearchChatContentScreenProps> = (props) => {
  return (
    <PageRoot>
      <SearchChatContent {...props}/>
    </PageRoot>
  )
}

export default GroupChatManagementScreen
